import script from "./OrderStatusSelectInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderStatusSelectInput.vue?vue&type=script&setup=true&lang=ts"

import "./OrderStatusSelectInput.vue?vue&type=style&index=0&id=31ab4623&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ab4623"]])

export default __exports__